<template>
  <v-card v-if="model.id" class="elevation-2">
    <v-card-title class="text-h5">
      <h2 class="font-weight-bold text--primary"> Proveedor </h2>
    </v-card-title>
    <v-card-subtitle class="title text--black font-weight-black font-weight-bold">
        {{`[ ${model.folio} ]`}}
    </v-card-subtitle>

    <v-tabs v-model="tab" background-color="primary" align-with-title dark>
      <v-tabs-slider color="white"></v-tabs-slider>
      <v-tab href="#General">General</v-tab>
      <!-- <v-tab href="#two" @click="viewEquipo()">Equipo Computo</v-tab> -->
      <v-tab href="#Movimientos" @click="viewMovs(model.folio)">Bitácora de Movimientos</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
        <!-- General -->
        <v-tab-item value="General">
          <v-card width="auto" outlined>
            <v-card-text>
              <v-row dense>
                <v-col cols="12" sm="12" md="12">
                    <h3>Razón social</h3>
                    <hr>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">RFC: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.rfc}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="8">
                    <label class="font-weight-bold subtitle-1 text--primary">Nombre: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.nombre}}
                    </p>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Número de proveedor (SAF): </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.datos_saf.numero}}
                    </p>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Fecha de expedición (SAF): </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.datos_saf.fecha_expedicion}}
                    </p>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Fecha de vigencia (SAF): </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.datos_saf.fecha_vigencia}}
                    </p>
                </v-col>

                <v-col v-if="model.banco" cols="12" sm="12" md="6">
                    <label class="font-weight-bold subtitle-1 text--primary">Banco: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.banco.nombre}}
                    </p>
                </v-col>

                <v-col v-if="model.datos_bancarios" cols="12" sm="12" md="6">
                    <label class="font-weight-bold subtitle-1 text--primary">Cuenta Bancaria: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.datos_bancarios.cuenta}}
                    </p>
                </v-col>

                <v-col v-if="model.datos_bancarios" cols="12" sm="12" md="6">
                    <label class="font-weight-bold subtitle-1 text--primary">Clabe Bancaria: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.datos_bancarios.clabe}}
                    </p>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Estratificación MIPYMES: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.estratificacion_mipymes.toUpperCase()}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="8">
                    <label class="font-weight-bold subtitle-1 text--primary">Actividad economica: </label>
                    <p class="font-weight-bold text--secondary" v-if="model.actividad_enconomica">
                        {{model.actividad_enconomica.nombre }}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                    <label class="font-weight-bold subtitle-1 text--primary">Correo electronico: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.contacto.correo}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Telefono: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.contacto.telefono}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="2">
                    <label class="font-weight-bold subtitle-1 text--primary">Ext: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.contacto.ext}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Celular: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.contacto.celular}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Pagina web: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.pagina_web}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                    <h3>Domicilio fiscal</h3>
                    <hr>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Calle: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.domicilio_fiscal.calle}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Exterior: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.domicilio_fiscal.exterior}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Fraccionamiento: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.domicilio_fiscal.fraccionamiento}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Cp: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.domicilio_fiscal.cp}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Clave de municipio o delegación: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.domicilio_fiscal.clave_municipio}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Municipio o delegación: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.domicilio_fiscal.municipio}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Entidad: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.entidad.clave}} - {{model.entidad.nombre}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Tipo proveedor: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.tipo.toUpperCase()}}
                    </p>
                </v-col>
            </v-row>
            <v-row cols="12" v-if="model.tipo === 'moral'">
                <v-col cols="12" sm="12" md="12">
                    <h3>Representante legal</h3>
                    <hr>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Nombre(s) de la persona (física o moral): </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.representante_legal.nombres}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Primer apellido: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.representante_legal.apellido_paterno}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Segundo apellido: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.representante_legal.apellido_materno}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">RFC: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.representante_legal.rfc}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Correo: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.representante_legal.contacto.correo}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Telefono: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.representante_legal.contacto.telefono}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Tipo de acreditación legal: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.representante_legal.apellido_materno}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                    <h3>Domicilio Persona Física</h3>
                    <hr>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Calle: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.representante_legal.domicilio_fiscal.calle}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Exterior: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.representante_legal.domicilio_fiscal.exterior}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Fraccionamiento: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.representante_legal.domicilio_fiscal.fraccionamiento}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary">Cp: </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.representante_legal.domicilio_fiscal.cp}}
                    </p>
                </v-col>
            </v-row>
        </v-card-text>
        </v-card>
        </v-tab-item>

        <!-- Inventario -->
        <v-tab-item value="two">
          <v-card width="auto" outlined>
            <v-card-text>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Bitacorra -->
        <v-tab-item value="Movimientos">
          <v-card width="auto" outlined>
            <v-card-text>
              <v-row dense>
                <v-col v-if="showMovs" cols="12">
                  <ViewMovementsField :itemAction="movs" />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
    </v-tabs-items>
  </v-card>
  <!--
  <v-card v-if="model.id" class="elevation-2">
    <v-card-text>
    </v-card-text>
  </v-card>
-->
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ViewMovementsField from '@/components/fields/specific/ViewMovementsField'
export default {
  props: ['model'],
  data: () => ({
    tab: 0,
    movs: {
      field: 'showMovsDataServer',
      name: '',
      nameid: 'movimientos',
      url: '/procesos/movimientos',
      default: '/procesos/movimientos',
      hidden: true,
      cols: 12
    },
    showMovs: false,
    showEq: false,
    itemInsumos: {}
  }),
  components: {
    ViewMovementsField
  },
  methods: {
    ...mapMutations(['SHOW_DIALOG_MAIN']),
    successAction (item) {
      this[item.action](item)
    },
    addInsumosView (item) {
      this.itemInsumos = {}
      this.itemInsumos = Object.assign({}, item.item)
      this.SHOW_DIALOG_MAIN({ type: 'addInsumos', with: 900, title: 'Agregar Insumos' })
    },
    returnedInsumosView (item) {},
    viewMovs (folio) {
      this.showMovs = false
      this.movs.url = `${this.movs.default}?folio=${folio}&mov=all`
      setTimeout(() => { this.showMovs = true }, 200)
    },
    viewEquipo () {
      /*
        if (this.model.descripcion.equipo) return
        this.showEq = false
        const router = this.get_urls['catalogo.familias-caracteristica.formulario']
        this.urlGetServiceActionTwo({ url: router, params: `/${this.model.descripcion.inventario.caracteristicas.familia_id}`, replace: '/{id}' })
        setTimeout(() => { this.showEq = true }, 200)
      */
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain'])
  },
  watch: {
    model (obj) {
      this.tab = 0
    }
  }
}
</script>
<style>
</style>
